module.exports = __webpack_public_path__ + "static/media/policy.62806fb3.svg";